import React from 'react';
import ReportPage from './components/ReportPage';
import WorkflowsByRequestersList from './components/WorkflowsByRequestersList';
import { useAppSelector } from '../../hooks';

function WorkflowsByRequesters() {
  const currentUser = useAppSelector((state) => state.auth);
  return (
    <ReportPage title="Workflows by requesters">
      <WorkflowsByRequestersList currentUser={currentUser} />
    </ReportPage>
  );
}

export default WorkflowsByRequesters;
